import PlayersReport from '@/layouts/statistics/players-reports/players-reports.vue';
import StatisticsList from '@/layouts/statistics/statistics-list/statistics-list.vue';
import TopList from '@/layouts/statistics/top-list/top-list';
import { computed, defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { usePermissionsStore } from '@/store/permissions.store';

export default defineComponent({
  name: 'StatisticsPage',
  components: { PlayersReport, StatisticsList, TopList },
  setup() {
    const { statisticsPermission } = storeToRefs(usePermissionsStore());

    const isPlayersReportAllowed = computed<boolean>(() => statisticsPermission.value.isGetPlayersReportCountAllowed);
    const isTopListAllowed = computed<boolean>(() => statisticsPermission.value.isGetTopWinsHistoryListAllowed);
    const isStatisticsListAllowed = computed<boolean>(
      () => statisticsPermission.value.isGetStatisticsReportListAllowed,
    );

    return {
      isPlayersReportAllowed,
      isTopListAllowed,
      isStatisticsListAllowed,
    };
  },
});
